import { IsiComponentV4 } from "./IsiComponentV4";
import { IIsiComponentManager } from "../Manager/IIsiComponentManager";

export class IsiComponentFactory {

    private _registredComponents;
    private _mutationObserverConfig: MutationObserverInit;
    private _mutationObserver: MutationObserver;
    private _componentManager: IIsiComponentManager;

    constructor(componentManager: IIsiComponentManager) {

        this._registredComponents = {};
        this._mutationObserverConfig = { childList: true, subtree: true };
        this._mutationObserver = new MutationObserver((mutationsList, observer) => {
            this._mutationsObserved(mutationsList, observer);
        });
        this._componentManager = componentManager;
    }

    /**
        * Elle permet de créer une surveillance du contenu d'un élément html
        * dans le but de créer automatiquement des composants.
        * @param uniqueId - L'identifiant unique de la configuration enregistré.
        * @param container - L'élément html qui sera surveillé (ou un sélecteur jQuery qui permet de le retrouver).
        * @param  createComponentDefinitionConfig - La configuration nécessaire à la création du composant.
        */
    registerComponent(uniqueId: string, container: JQuery, createComponentDefinitionConfig: IsiCreateComponentDefinitionEmptyConfig) {
        let jContainerElement = jQuery(container);
        if (jContainerElement.length > 0) {
            this._registredComponents[uniqueId] = {
                container: jContainerElement,
                definition: new IsiCreateComponentDefinition(createComponentDefinitionConfig)
            }
            this._createOberser(jContainerElement[0]);
        } else {
            console.warn("[IsiComponentsFactory] Impossible de trouver le container à partir du sélecteur : " + container)
        }
    }

    _createOberser(container) {
        // On vérifie qu'il n'y a pas un observer de créé sur un parent.
        if (jQuery(container).closest("[data-cp-observed]").length == 0) {
            if (jQuery(container).find("[data-cp-observed]").length == 0) {
                this._mutationObserver.observe(container, this._mutationObserverConfig);
                jQuery(container).attr("data-cp-observed", "1")
            } else {
                console.error("[IsiComponentsFactory] Impossible de créer un observer car un ou plusieurs enfants sont déjà obsevés.")
            }
        }
    }

    _mutationsObserved(mutationsList, observer) {
        let nbMutation = mutationsList.length;
        for (var idxMutation = 0; idxMutation < nbMutation; idxMutation++) {
            this._checkNodes(mutationsList[idxMutation]);
        }
    }

    _checkNodes(mutation) {
        let nbRemovedNodes = mutation.removedNodes.length
        for (var idxRemovedNode = 0; idxRemovedNode < nbRemovedNodes; idxRemovedNode++) {
            this._searchDisposableComponent(jQuery(mutation.removedNodes[idxRemovedNode]));
        }

        let nbAddedNodes = mutation.addedNodes.length;
        for (var idxAddedNode = 0; idxAddedNode < nbAddedNodes; idxAddedNode++) {
            this._searchComponentsInNode(jQuery(mutation.addedNodes[idxAddedNode]));
        }
    }

    _searchDisposableComponent(jNode) {
        if (jNode.is("[data-cp-created]")) {
            this._disposeComponent(jNode)
        } else {
            jNode.find("[data-cp-created]").each(function (me) {
                return function () {
                    me._disposeComponent(jQuery(this));
                };
            }(this))
        }
    }

    _disposeComponent(jNode) {
        let id = jNode.attr("id");
        if (id) {
            // Si on a créé un élément light, l'identifiant n'est pas présent.
            let component = this._componentManager.getComponent(id);
            component && component.dispose();
        }
    }

    _searchComponentsInNode(jNode) {
        let isCp = false;
        const isComponentFilter = "[data-cp-id]:not([data-cp-created])";

        if (jNode.is(isComponentFilter)) {
            this._createComponents(jNode);
        } else {
            const cpNodes = jNode.find(isComponentFilter);
            cpNodes.each(function (me) {
                return function () {
                    me._createComponents(jQuery(this));
                };
            }(this))
        }


        return isCp;
    }

    _createComponents(jComponentNode) {
        let datas = this._extractComponentDatas(jComponentNode);
        let componentInfos = this._registredComponents[datas.defintionId];

        if (componentInfos) {
            let id = componentInfos.definition.getComponentId(jComponentNode, datas);
            let properties = componentInfos.definition.getComponentProperties(jComponentNode, datas);
            let typeComponent = componentInfos.definition.getComponentType();
            if (componentInfos.definition.hasLightElement()) {
                let cptElement = componentInfos.definition.getLightElement(jComponentNode, properties, datas);
                cptElement.click((event) => {
                    // On annule le click pour qu'il ne s'applique pas au nouveau composant.
                    event.preventDefault();
                    event.stopPropagation();
                    // On vide le contenu du container afin de supprimer l'élément light avant de créer proprement le composant.
                    jComponentNode.html('');
                    jComponentNode.attr("data-cp-created", "1");
                    this.createComponent(typeComponent, id, null, properties, jComponentNode, (cp) => {
                        componentInfos.definition.onComponentCreated(cp, datas);
                    });
                });

            } else {
                // on applique l'attribut marquant que le composant est créé avant la création effective,
                // de manière à éviter que le "mutation observer" ne se déclanche trop de fois.
                // Ce cas s'est présenté dans la gestion de la sélection dans la grille hiérarchique (droit profil par écrans dans IWS)
                // (avant l'attribut était appliqué dans le callback)
                jComponentNode.attr("data-cp-created", "1");
                this.createComponent(typeComponent, id, null, properties, jComponentNode, (cp) => {
                    componentInfos.definition.onComponentCreated(cp, datas);
                });

            }

        }
    }

    _extractComponentDatas(jComponentNode) {
        let datas = {
            defintionId: jComponentNode.attr("data-cp-id") || console.warn("L'attribut data-cp-id est obligatoire"),
        };

        jQuery.each(jComponentNode[0].attributes, function () {
            if (this.specified && this.name.indexOf("data-") == 0) {
                let nameParts = this.name.substr(5).split("-");
                let namePart = nameParts.shift();
                let nameWithoutHyphen = namePart.toLowerCase();
                while (nameParts.length > 0) {
                    namePart = nameParts.shift();
                    nameWithoutHyphen += namePart.charAt(0).toUpperCase() + namePart.slice(1);
                }

                datas[nameWithoutHyphen] = this.value;
            }
        });

        return datas;
    }

    isV4(component) {
        return component instanceof IsiComponentV4
    }

    /**
    * Créér un componsant en async.
    * @param type - Le type du composant
    * @param id - L'identfiant UNIQUE du composant
    * @param container - L'élément HTML dans lequel sera ajouté le composant ou null si le composant est déjà dans le DOM.
    * @param properties - Les propriétés du composant à créer
    * @param  element - L'élément HTML qui représente la base du composant ou null pour une création automatique
    * @return L'instance du composant
    */
    createComponentAsync(type: string, id: string, container: JQuery, properties: any, element?: JQuery): Promise<IsiComponentV4> {
        return new Promise<IsiComponentV4>((resolve) => {
            this.importComponent(type).then((module) => {
                let object = this.createComponent(module, id, container, properties, element);
                resolve(object);
            });
        });
    }

    /**
    * Créér un componsant.
    * @param type - Le type du composant
    * @param id - L'identfiant UNIQUE du composant
    * @param container - L'élément HTML dans lequel sera ajouté le composant ou null si le composant est déjà dans le DOM.
    * @param properties - Les propriétés du composant à créer
    * @param  element - L'élément HTML qui représente la base du composant ou null pour une création automatique
    * @return L'instance du composant
    */
    createComponent(type: string | object, id: string, container: JQuery, properties: any, element?: JQuery, callBack?: any) {
        // <summary>
        // Cette fonction permet de créer le composant coté client (balise html + objet JS)
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>
        if (typeof type === "string") {
            this.importComponent(type).then((module) => {
                this.createComponent(module, id, container, properties, element, callBack);
            });
        } else {

            var jElement = this._createElement(type, id, container, element);

            var object = this._createObject(type, id, properties, jElement);
            if (callBack) {
                callBack(object);
            }

        }

        return object;
    }

    /**
    * Créer la structure HTML d'un componsant.
    * @param {Type} type - Le type du composant
    * @param {string} id - L'identfiant UNIQUE du composant
    * @param {string|Element|jQueryElement} container - L'élément HTML dans lequel sera ajouté le composant ou null si le composant est déjà dans le DOM.
    * @param {string|Element|jQueryElement} element - L'élément HTML qui représente la base du composant ou null pour une création automatique
    * @return {jQueryElement} L'élément HTML qui représente la base
    */
    _createElement(type: any, id: string, container: JQuery, element: JQuery) {
        // <summary>
        // Cette fonction permet de créer la partie html du composant coté client
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>

        var jRoot: JQuery;

        if (typeof (element) == 'undefined') {
            jRoot = jQuery('<div></div>');
        } else {
            jRoot = jQuery(element);
        }
        jRoot.attr("id", id);

        var classnames = [];
        var t = type;
        while (t && t.name !== "IsiComponent" && t.name !== "IsiComponentV3") {
            if (t["clsName"]) {
                classnames.unshift(t.clsName);
            } else {
                classnames.unshift(t.name);
            }

            t = Object.getPrototypeOf(t);
        }

        jRoot.addClass(classnames.join(" "));
        jRoot.attr("tp", "1");

        if (container) {
            jQuery(container).append(jRoot);
        }

        return jRoot;
    }

    /**
    * Elle permet de créer l'instance du composant.
    * @param {Type} type - Le type du composant
    * @param {Object} properties - Les propriétés du composant à créer
    * @param {jQueryElement} jElement - L'élément HTML qui représente la base du composant ou null pour une création automatique
    * @return {Object} L'instance du composant
    */
    _createObject(type: any, id: string, properties: any, jElement: JQuery) {
        // <summary>
        // Cette fonction permet de créer l'objet JS du composant coté client
        // </summary>
        // <history>
        //		 <entry mat="gbau" date="09/03/2015 14:15:53" task="DEV103668">Création</entry>
        // <history>

        var object;
        var element;
        element = jElement[0];

        if (type.getDefaultProperties) {
            properties = jQuery.extend(true, type.getDefaultProperties(), properties);
        }

        //Instanciation de l'objet IsiTouchPad
        object = new type(element);
        for (var i in properties) {
            object["set_" + i](properties[i]);
        }

        object.initialize();
        //object = $create((IsiTouchPad) as any, properties, null, null, element);

        return object;
    }

    importComponent(name: string): Promise<any> {
        return new Promise((resolve: (type: any) => void, reject): void => {
            if (name.startsWith("IsiFW.")) {
                let scriptName = name.replace("IsiFW.Components.", "").IsiReplaceAll("\\.", "/");
                import(
                    /* webpackChunkName: "Components/[request]" */
                    `./../../Components/${scriptName}.component`).then((module) => {
                        resolve(module[name.split(".").pop()]);
                    }).catch((e) => {
                        console.log(e)
                    });
            } else {
                const rootNamespace = name.split(".").shift();
                import(
                    /* webpackChunkName: "Components/[request]" */
                    `../../../Components/${name.IsiReplaceAll("\\.", "/")}.component`).then((module) => {
                        resolve(module[name.split(".").pop()]);
                    }).catch((e) => {
                        console.log(e)
                    });
            }

        });
    }

    //    // Gestion de l'instance unique du singleton
    //    var instance = null;
    //return new function () {
    //    this.getInstance = function () {
    //        if (instance == null) {
    //            instance = new constructeur();
    //            instance.constructeur = null;
    //        }

    //        return instance;
    //    }
    //}
}

///**
// * Elle permet de créer un componsant.
// * @param {Type} type - Le type du composant
// * @param {string} id - L'identfiant UNIQUE du composant
// * @param {string|Element|jQueryElement} container - L'élément HTML dans lequel sera ajouté le composant ou null si le composant est déjà dans le DOM.
// * @param {Object} properties - Les propriétés du composant à créer
// * @param {string|Element|jQueryElement} element - L'élément HTML qui représente la base du composant ou null pour une création automatique
// * @return {Object} L'instance du composant
// */
//IsiFW.Components.Factory.IsiComponentsFactory.CreateComponent = function (type, id, container, properties, element) {
//    var element = IsiFW.Components.Factory.IsiComponentsFactory.CreateElement(type, id, container, element);
//    var object = IsiFW.Components.Factory.IsiComponentsFactory.CreateObject(type, properties, element);

//    return object;
//}

///**
// * Elle permet de créer un componsant.
// * @param {Type} type - Le type du composant
// * @param {string} id - L'identfiant UNIQUE du composant
// * @param {string|Element|jQueryElement} container - L'élément HTML dans lequel sera ajouté le composant ou null si le composant est déjà dans le DOM.
// * @param {string|Element|jQueryElement} element - L'élément HTML qui représente la base du composant ou null pour une création automatique
// * @return {jQueryElement} L'élément HTML qui représente la base
// */
//IsiFW.Components.Factory.IsiComponentsFactory.CreateElement = function (type, id, container, element) {
//    var jRoot;

//    if (typeof element === 'undefined') {
//        jRoot = jQuery('<div></div>');
//    } else {
//        jRoot = jQuery(element);
//    }

//    var cssClasses = [];
//    var baseType = type;
//    while (baseType && (typeName = baseType.getName().split(".").pop()) && typeName !== "IsiComponent" && typeName !== "IsiComponentV3") {
//        cssClasses.push(typeName);
//        baseType = baseType.getBaseType();
//    }

//    jRoot.addClass(cssClasses.join(" "));
//    jRoot.attr("id", id);
//    jRoot.attr("tp", "1");

//    if (container) {
//        jQuery(container).append(jRoot);
//    }

//    return jRoot;
//}

///**
// * Elle permet de créer l'instance du composant.
// * @param {Type} type - Le type du composant
// * @param {Object} properties - Les propriétés du composant à créer
// * @param {jQueryElement} jElement - L'élément HTML qui représente la base du composant ou null pour une création automatique
// * @return {Object} L'instance du composant
// */
//IsiFW.Components.Factory.IsiComponentsFactory.CreateObject = function (type, properties, jElement) {
//    var object;
//    var element;
//    element = jElement[0];

//    if (typeof (type.getDefaultProperties) !== 'undefined') {
//        properties = jQuery.extend(true, type.getDefaultProperties(), properties);
//    }

//    object = $create(type, properties, null, null, element);

//    return object;
//}


/**
 * Squellete vide d'une configuration de création automatique de componsant.
 */
class IsiCreateComponentDefinitionEmptyConfig {

    autoGenerateId: boolean;
    /**
     * La fonction appelée pour récupérer le type du composant.
     * @return {Type} Le type du composant
     */
    componentTypeNeeded() {
        console.warn("[IsiComponentsFactory] componentTypeNeeded ne peut pas être null");
    }

    /**
     * La fonction appelée pour créer un élément light.
     * @return {element} Le code HTML correspondant au composant light
     */
    lightElementNeeded?: (id, container, properties, element) => void;

    /**
     * La fonction appelée pour récupérer l'identifiant du composant à créer.
     * @param {jQueryElement} element - L'élément html qui a déclenché la création du composant
     * @param {Object} datas - Contient la valeur des attributs data- récupéré sur l'élément html qui a déclenché la création du composant
     * @return {string} L'identifiant UNIQUE du composant
     */
    componentIdNeeded(element, datas) {
        console.warn("[IsiComponentsFactory] componentIdNeeded ne peut pas être null");
    };

    /**
     * La fonction appelée pour récupérer les propriétés du composant à créer.
     * @param {jQueryElement} element - L'élément html qui a déclenché la création du composant
     * @param {Object} datas - Contient la valeur des attributs data- récupéré sur l'élément html qui a déclenché la création du composant
     * @return {Object} Les propriétés du composant
     */
    componentPropertiesNeeded(element, datas) {
        console.warn("[IsiComponentsFactory] componentPropertiesNeeded ne peut pas être null");
    };

    /**
     * La fonction appelée une fois le composant créé.
     * Elle permet par exemple de s'abonner aux événements du composant créé.
     * @param {Object} cp - L'instance du componsant qui vient d'être créé
     * @param {Object} datas - Contient la valeur des attributs data- récupéré sur l'élément html qui a déclenché la création du composant
     */
    componentCreated(cp, datas) {

    };
};

/**
 * Façade qui permet encapsule une configuration de création automatique de componsant.
 */
class IsiCreateComponentDefinition {

    private _config: any;
    private static _idGenerator: number = 0;

    constructor(config) {
        this._config = jQuery.extend(
            true,
            new IsiCreateComponentDefinitionEmptyConfig(),
            config);
    }
    getComponentType() {
        return this._config.componentTypeNeeded();
    }
    hasLightElement() {
        return (this._config && (typeof this._config.lightElementNeeded === "function"));
    }
    getLightElement(id, container, properties, element) {
        return this._config.lightElementNeeded(id, container, properties, element);
    }
    getComponentId(element, datas) {
        let cpId;
        if (this._config.autoGenerateId === true) {
            cpId = "IsiCpAutoId-" + IsiCreateComponentDefinition._idGenerator++;
        } else {
            cpId = this._config.componentIdNeeded(element, datas);
        }
        return cpId;
    }
    getComponentProperties(element, datas) {
        return this._config.componentPropertiesNeeded(element, datas);
    }
    onComponentCreated(cp, datas) {
        this._config.componentCreated.call(this, cp, datas)
    }
}